"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowProfile = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var LangSelector_1 = require("./LangSelector");
var i18n_1 = __importDefault(require("../i18n"));
var BrowserWarning_1 = require("./BrowserWarning");
var ShowProfileUser_1 = require("./ShowProfileUser");
var api_1 = require("../api");
var util_1 = require("../util");
var componentWorldToWorlds_1 = require("../hocs/componentWorldToWorlds");
var SiteTitle_1 = require("./SiteTitle");
var sentry_1 = require("../sentry");
var TitleHelmet_1 = require("./TitleHelmet");
var ShowProfileUserByWorlds = (0, componentWorldToWorlds_1.componentWorldToWorlds)(ShowProfileUser_1.ShowProfileUser);
var dummyUser = {
    id: "",
    username: "",
    displayName: "",
    status: "active",
    statusDescription: "",
    currentAvatarImageUrl: "",
    currentAvatarThumbnailImageUrl: "",
    location: "",
    travelingToLocation: "",
    locationInfo: {
        permission: "none",
    },
    note: "",
};
var ShowProfile = function (state) {
    loadUser(state);
    return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Container, { style: { paddingTop: "1em" }, children: [(0, jsx_runtime_1.jsx)(TitleHelmet_1.TitleHelmet, { title: state.showProfileUser ? state.showProfileUser.displayName : state.username }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { columns: 1, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid, { columns: 2, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { width: 11, children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/", children: (0, jsx_runtime_1.jsx)(SiteTitle_1.SiteTitle, {}) }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { width: 5, textAlign: "right", children: (0, jsx_runtime_1.jsx)(LangSelector_1.LangSelector, { setLang: state.setLang }) })] }) }), (0, jsx_runtime_1.jsx)(BrowserWarning_1.BrowserWarning, {}), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: state.showProfileUserLoading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: state.showProfileUserLoading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), 
                                // eslint-disable-next-line eqeqeq
                                state.showProfileUser === null ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Message, { style: { color: "black" }, children: i18n_1.default.showProfileNotFound })) : ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, { centered: true, columns: 1, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { style: { width: "max-content" }, children: (0, jsx_runtime_1.jsx)(ShowProfileUserByWorlds, { user: state.showProfileUser || dummyUser, worlds: state.worlds, needWorldIds: state.needWorldIds, missingWorldIds: state.missingWorldIds }) }) }))] }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Segment, { textAlign: "center", children: (0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { to: "/", children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "comment" }), i18n_1.default.showProfileDescription] }) }) }) })] })] }));
};
exports.ShowProfile = ShowProfile;
var loadUser = function (state) { return __awaiter(void 0, void 0, void 0, function () {
    var user, e_1, profile, userModel, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (state.showProfileUserLoading || state.showProfileUser !== undefined)
                    return [2 /*return*/];
                state.setShowProfileUserLoading(true);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 9, 10, 11]);
                user = void 0;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, (0, api_1.fetchUserByName)(state.username)];
            case 3:
                user = _a.sent();
                return [3 /*break*/, 5];
            case 4:
                e_1 = _a.sent();
                (0, sentry_1.captureException)(e_1); // スルー
                return [3 /*break*/, 5];
            case 5:
                if (!user) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, api_1.fetchProfile)(user.id)];
            case 6:
                profile = _a.sent();
                userModel = __assign(__assign({}, user), { profile: profile, locationInfo: (0, util_1.parseUserLocation)(user) });
                state.setShowProfileUser(userModel);
                return [3 /*break*/, 8];
            case 7:
                state.setShowProfileUser(null);
                _a.label = 8;
            case 8: return [3 /*break*/, 11];
            case 9:
                e_2 = _a.sent();
                state.setShowProfileUser(null);
                (0, sentry_1.captureException)(e_2);
                alert(e_2);
                return [3 /*break*/, 11];
            case 10:
                state.setShowProfileUserLoading(false);
                return [7 /*endfinally*/];
            case 11: return [2 /*return*/];
        }
    });
}); };
